<script lang="ts">
  import { tStore } from '../i18n'
  import { ALLOWED_COUNTRY_CODES, type CountryCode } from '../api/procurements'
  import Dropdown from './Dropdown.svelte'

  interface Props {
    value: CountryCode | undefined
    id?: string
  }

  let { value = $bindable(), id }: Props = $props()

  const options = $derived([
    { value: undefined, label: $tStore('common.all') },
    ...ALLOWED_COUNTRY_CODES.map((code) => ({ value: code, label: $tStore(`countries.${code}`) })),
  ])
</script>

<Dropdown bind:value {id} {options} />
